import { Flex, Image } from '@mantine/core';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SelectLanguage } from '@common/components';
import LogoImage from 'src/assets/svg/logo.svg';
import { PATHS } from 'src/constants';

import styles from './styles.module.scss';

const AuthHeder = (): JSX.Element => {
  const [t] = useTranslation('nav');

  return (
    <header className={styles.header}>
      <Flex id="language-container" align={'center'} justify={'space-between'}>
        <Link id="main-logo" to={PATHS.WEBSITE} >
          <Image width={142} src={LogoImage} alt={t('logoAlt') ?? undefined} />
        </Link>
        {/* <SelectLanguage className={styles['header-select']} /> */}
      </Flex>
    </header>
  );
};

export default AuthHeder;
